import withStyles from "@material-ui/core/styles/withStyles";
import extendedTablesStyle from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle";
import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";

function TituloPagina2({ texto, color, classes, className, style, icono }) {
  const tituloClasses = classNames({
    [classes[color + "TituloPagina2"]]: color,
    [className]: className,
  });

  return (
    <div className={tituloClasses} style={style}>
      {icono && (
        <span style={{ marginRight: "8px", fontSize: "1.2rem" }}>
          {icono}
        </span>
      )}
      {texto}
    </div>
  );
}

TituloPagina2.defaultProps = {
  color: "info",
};

TituloPagina2.propTypes = {
  texto: PropTypes.string.isRequired,
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  color: PropTypes.oneOf([
    "warning",
    "success",
    "danger",
    "info",
    "primary",
    "rose",
    "green",
  ]),
  style: PropTypes.object,
  icono: PropTypes.node, // 👈 para permitir emojis o componentes React
};


//export default TituloPagina2;
export default withStyles(extendedTablesStyle)(TituloPagina2);
